<template>
  <form @submit.prevent="save" class="w-m-content page-editor" v-if="!loading">
    <div class="w-m-header">
      <div class="flex">
        <p class="font-14 font-bold no-margin col-grow" style="color: #293e52">Categoria do Blog</p>
        <div class="">
          <!--<u-btn size="sm" flat label="Variáveis" icon="eye" icon-type="fa" @click="$refs.vars.show()" />-->
        </div>
      </div>
      <!--<div class="m-t-xs font-13 text-grey-7" style="color: #748396; padding-right: 20px; line-height: 1">Esta seção
        autoriza uma pessoa a acessar o software, com suas respectivas permissões.
      </div>-->
    </div>
    <div class="w-m-body e-input-modern flex">
      <div style="min-height: 400px" class="flex column w-full">
        <e-row class="m-b-sm font-bold">
          Nome:
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input autofocus simple-border required placeholder="Ex.: Investimentos, Dicas, etc"
                       v-model="model.name" />
          </e-col>
        </e-row>

        <e-row mr>
          <e-col>
            <e-row class="m-b-sm font-bold">
              Descrição:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <textarea class="sl-textarea" style="height: 100px" required
                           v-model="model.description" />
              </e-col>
            </e-row>
          </e-col>
        </e-row>

      </div>
    </div>
    <div class="w-m-footer text-right">
      <u-btn type="submit" :label="id ? 'Atualizar' : 'Cadastrar'" :disable="!ready" no-caps
             :color="ready ? 'primary' : 'blue-grey-2'"
             class="b-radius-3px" />
    </div>
  </form>
  <window-loading :errors="errors" :status="status" v-else />
</template>

<script>
import ERow from '../../../../../layout/components/Row'
import {ErpInput} from 'uloc-vue-plugin-erp'
import ECol from '../../../../../layout/components/Col'
import WindowLoading from '../../../../../layout/window/Loading'
import {
  newCategoria as create,
  updateCategoria as update,
  find
} from '@/domain/blog/services/categoria'

let mock = {
  id: null,
  name: null,
  description: null,
  active: true,
}

export default {
  name: 'PaginasWindowModern',
  components: {
    WindowLoading,
    ECol,
    ERow,
    ErpInput,
    //UEditor,
    // UToggle
  },
  props: ['props', 'id'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock)),
      loading: !!this.id,
      errors: null,
      success: false,
      status: null,
      source: false,
      textEditing: false
    }
  },
  mounted () {
    this.id && this.load()
  },
  computed: {
    mock () {
      return mock
    },
    ready () {
      let model = this.model
      return model.name && String(model.name).length > 1;
    }
  },
  methods: {
    load () {
      find(this.id)
        .then(response => {
          this.model = response.data
          this.loading = false
        })
        .catch(error => {
          this.alertApiError(error)
          this.loading = false
        })
    },
    excluir () {
      this.$uloc.dialog({
        title: `Tem certeza que deseja excluir esta página?`,
        message: 'Digite EXCLUIR e clique para confirmar:',
        prompt: {
          model: '',
          type: 'text' // optional
        },
        cancel: true,
        color: 'negative'
      }).then(data => {
        if (data.toUpperCase() !== 'EXCLUIR') {
          this.$uloc.notify({
            color: 'negative',
            message: `Você não confirmou a operação. Exclusão não efetuada.`
          })
          return
        }
        this.$uloc.notify({
          color: 'negative',
          message: `Excluindo template...`
        })
        deleteConteudo(this.id)
          .then(response => {
            this.$uloc.notify({
              color: 'positive',
              message: `Página deletada com sucesso!`
            })
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.$uloc.window.close(this.$root.wid)
          })
          .catch(error => {
            this.alertApiError(error)
          })
      }).catch(() => {
      })
    },
    save () {
      console.log('Save')
      this.loading = true

      let data = this.model

      let method = this.id ? (data) => update(this.id, data) : create
      method(data)
        .then(({data}) => {
          this.success = true
          Object.assign(this.model, data)
          this.$nextTick(() => {
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.loading = false
            this.dg()
            // this.$refs.timer.start()
          })
        })
        .catch(error => {
          this.success = false
          this.errorMessage = error.data.message
          // this.errors = this.systemError(error)
          this.$nextTick(() => {
            this.loading = false
            this.alertApiError(error)
            // this.error = true
          })
        })
    }
  }
}
</script>

<style lang="stylus">
.page-editor {
  .sl-editor-content {
    min-height 500px
  }
}
</style>
